import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import voiceHandler from './voiceHandler.es6';
export default class Banner {
    constructor() {
        this.voiceHandler = null;
        this.init();
    }

    init() {
        this.setSwiper();
        this.setGallerySwiper();
        this.setModalSwiper();
        this.voiceHandler = new voiceHandler();
    }

    setSwiper() {
        const slides = [...document.querySelectorAll('.js-thumbnail-swiper .swiper-slide')];
        const mql = window.matchMedia('(max-width: 959px)');
        const btnIcon = document.querySelector('[data-slider-icon]');

        const option = {
            autoplay: { delay: 6000, disableOnInteraction: false },
            speed: 400,
            pagination: { el: '.swiper-pagination', clickable: true },
            spaceBetween: 12,
            // allowTouchMove: mql ? true : false,
        };

        if (slides.length < 2) {
            btnIcon.addEventListener('click', () => {
                slides[0].children[0].dispatchEvent(new PointerEvent('click'));
            });
        } else {
            const swiper = new Swiper('.js-thumbnail-swiper', option);
            btnIcon.addEventListener('click', () => {
                const activeSlide = slides[swiper.activeIndex];
                const targetModal = activeSlide.children[0];
                targetModal.dispatchEvent(new PointerEvent('click'));
            });
        }
    }

    setGallerySwiper() {
        // サムネイル用のSwiperを先に定義
        const swiperThumbs = new Swiper('.js-gallery-swiper', {
            autoplay: { delay: 6000, disableOnInteraction: false },
            speed: 400,
            slidesPerView: 3,
            breakpoints: {
                600: {
                    direction: 'vertical',
                },
            },
        });

        // メインのSwiperをサムネイルと連携
        const swiperMain = new Swiper('.js-gallery-swiper-main', {
            autoplay: { delay: 6000, disableOnInteraction: false },
            speed: 400,
            spaceBetween: 12,
            pagination: { el: '.swiper-pagination', clickable: true },
            thumbs: {
                swiper: swiperThumbs,
            },
        });
    }

    setModalSwiper() {
        const slides = [...document.querySelectorAll('.bddvd__tokuten__modal .swiper-slide')];
        //console.log(slides.length);

        const option = {
            loop: true,
            pagination: { el: '.swiper-pagination', clickable: true },
        };

        const swiper = new Swiper('.bddvd__tokuten__modal__cont', option);
    }
}
